import EditCollectionNameModal from './EditCollectionNameModal.container'
export default EditCollectionNameModal
